import { useCommanderSelector } from '@mews-commander/utils';
import { isCurrentEnterprisePortfolio } from '@mews-commander/legacy-entities';
import { ArticlePath, createGuideLink } from '@mews-commander/enums';
import { PortfolioLayout, QueryBoundary, SuspenseBoundary } from '@mews-commander/ui';
import { RolesProvider } from './context';
import { PortfolioRolesListHeader } from './RolesList/PortfolioRolesListHeader';
import { PropertyRolesLayout } from './RolesList/PropertyRolesLayout';
import { RolesList } from './RolesList';

export const LegacyRolesPage = () => {
    const isPortfolio = useCommanderSelector(isCurrentEnterprisePortfolio);
    const guideLink = createGuideLink(ArticlePath.SetUpAndCustomizeRolesMultiProperty);

    return (
        <RolesProvider>
            <QueryBoundary>
                {isPortfolio ? (
                    <PortfolioLayout>
                        <PortfolioRolesListHeader guideLink={guideLink} />
                        <SuspenseBoundary>
                            <RolesList />
                        </SuspenseBoundary>
                    </PortfolioLayout>
                ) : (
                    <PropertyRolesLayout>
                        <SuspenseBoundary>
                            <RolesList />
                        </SuspenseBoundary>
                    </PropertyRolesLayout>
                )}
            </QueryBoundary>
        </RolesProvider>
    );
};
